export default __webpack_public_path__ + "static/media/817.b58de0b0.png";